import {
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  TablePagination,
} from "@mui/material";
import { portalStore } from "../../../../Stores/portal";
import { ChangeEventHandler, useEffect, useState } from "react";
// import { BASE_URL } from "../../../../firebase";
import { Transaction } from "../../../../Model/transaction";
import axios from "axios";

export const AccountingTransactions: React.FC = () => {
  const [page, setPage] = useState(0); // Current page, 0-indexed
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [numberOfTransactions, setNumberOfTransactions] = useState(0);

  const handleChangePage = (_event: any, newPage: number) => {
    setPage(newPage);
  };

  const fetchTransactions = async () => {
    const storeId = "317f6c74-02a6-11f0-962e-0a67fa16b369"; //TODO_SAI
    await axios
      .get(
        `https://wallof-backend.uc.r.appspot.com/accounting/transactions/count/${storeId}/`,
      )
      .then((v) => {
        const data = v.data;
        const counter = (data as unknown as any)["data"][0];
        setNumberOfTransactions(counter["Counter"]);
      })
      .catch((e) => {
        console.log(e);
      });
    await axios
      .get(
        `https://wallof-backend.uc.r.appspot.com/accounting/transactions/${storeId}/${rowsPerPage}/${
          page == 0 ? 1 : page
        }`,
      )
      .then((v) => {
        const data = v.data;
        const trans_ = (data as unknown as any)["data"] as Transaction[];
        setTransactions(trans_);
      })
      .catch((_e) => {});
  };

  useEffect(() => {
    fetchTransactions();
  }, [page]);

  return (
    <>
      <TableContainer
        style={{ background: "transparent" }}
        sx={{ maxHeight: portalStore.portalHeight - 50, maxWidth: "100%" }}
      >
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow style={{ fontWeight: "bold" }}>
              <TableCell>ID</TableCell>
              <TableCell align="right">
                <b>Amount (ZAR)</b>
              </TableCell>
              <TableCell align="right">Total VAT</TableCell>
              <TableCell align="left">Type</TableCell>
              <TableCell align="left">Competitor</TableCell>
              <TableCell align="left">Status</TableCell>
              <TableCell align="left">Timestamp</TableCell>
              <TableCell align="left">Provider</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.map((row, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.TransactionID}
                </TableCell>
                <TableCell align="right">{row.Amount}</TableCell>
                <TableCell align="right">
                  {`${row.TotalVAT} `}
                  <span style={{ color: "gray" }}>{`(@ ${
                    row.VATConstant * 100
                  }%)`}</span>
                </TableCell>
                <TableCell align="left">{row.TransactionType}</TableCell>
                <TableCell align="left">{row.Player}</TableCell>
                <TableCell align="left">{row.Status}</TableCell>
                <TableCell align="left">
                  {row.TransactionDate.replace("T", " ").substring(
                    0,
                    row.TransactionDate.lastIndexOf("."),
                  )}
                </TableCell>
                <TableCell align="left">{row.Provider}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20, 50, 100]} // Options for the "Rows per page" dropdown
        component="div" // Can be a div, Paper, etc.
        count={numberOfTransactions} // Total number of rows in your dataset
        rowsPerPage={rowsPerPage} // Current number of rows per page
        page={page} // Current page number
        onPageChange={handleChangePage} // Callback when page changes
        onRowsPerPageChange={(event) => {
          setRowsPerPage(Number.parseInt(event.target.value));
          setPage(1);
        }}
        // onRowsPerPageChange={} // Callback when rows per page changes
      />
    </>
  );
};
